module.exports = __webpack_public_path__ + "img/consultation@2x.1b6e5e2.jpg";